/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
// セクションにIDを付与
document.addEventListener('DOMContentLoaded', function() {
  var mission = document.querySelector('.section--template--21285415158005__section_image_with_text_FV93mE');
  if (mission) mission.id = 'mission';

  var philosophy = document.querySelector('.section--template--21285415158005__section_image_with_text_frUtAf');
  if (philosophy) philosophy.id = 'philosophy';
});

// アンカーリンクのオフセット調整
window.addEventListener('load', function() {
  var hash = window.location.hash;
  if (!hash) return;

  setTimeout(function() {
    var target = null;
    if (hash === '#mission') {
      target = document.querySelector('.section--template--21285415158005__section_image_with_text_FV93mE');
    } else if (hash === '#philosophy') {
      target = document.querySelector('.section--template--21285415158005__section_image_with_text_frUtAf');
    } else {
      target = document.querySelector(hash);
    }

    if (target) {
      var offset = 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }, 500);
});